import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiNatureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_nature"}/>
}
